import { render, staticRenderFns } from "./BrigEngList.vue?vue&type=template&id=b9364418&scoped=true&"
import script from "./BrigEngList.vue?vue&type=script&lang=js&"
export * from "./BrigEngList.vue?vue&type=script&lang=js&"
import style0 from "./BrigEngList.vue?vue&type=style&index=0&id=b9364418&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9364418",
  null
  
)

export default component.exports